<h2 data-qa="archivedDFList-Headline">Archivierte Datenabfragen</h2>

<div fxLayout="column" fxLayoutGap="2rem">
  @for (archivedDatenabfrage of archivierteDatenabfragen; track archivedDatenabfrage.datenabfrage.id) {
    <mat-card>
      <mat-card-header>
        <mat-card-subtitle>Bezeichnung der Datenabfrage</mat-card-subtitle>
        <mat-card-title
        data-qa="datenabfrageCard-bezeichnung-text">{{archivedDatenabfrage.datenabfrage.bezeichnung}}</mat-card-title>
      </mat-card-header>
      <tnb-datenabfrage-card-content
        [aufteilungsSchluessels]="archivedDatenabfrage.archivierterAufteilungsschluessels"
        [datenabfrage]="archivedDatenabfrage.datenabfrage">
      </tnb-datenabfrage-card-content>
      <mat-card-actions>
        @if (isWestnetzAdmin) {
          <button (click)="deleteArchivierteDatenabfrage(archivedDatenabfrage.datenabfrage.id)"
            class="actionbutton button-warn"
            data-qa="button-delete-archivierteDatenabfrage"
            matButton="filled"
            aria-label="Datenabfrage löschen"
            >
            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            Löschen
          </button>
        }
        @if (isWestnetzAdmin) {
          <button (click)="csvExportArchivierteDatenfrage(archivedDatenabfrage.datenabfrage.id)"
            class="actionbutton"
            data-qa="button-csvexport-aktiveDatenabfrage" id="csvExportAktiveDatenfrage"
            matButton="outlined">
            <mat-icon>file_download</mat-icon>
            CSV exportieren
          </button>
        }
      </mat-card-actions>
    </mat-card>
  }
</div>
